import { LinkButton } from '@etg/wings';
import { css } from '@eti/styles';
import { useSnowplowTracking, useTranslation } from '@eti/providers';
import { CaretDown } from '@phosphor-icons/react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

const linkStyles = css`
  display: inline-block;
`;

const iconStyles = css`
  transform: rotate(90deg);

  [dir='rtl'] & {
    transform: rotate(-90deg);
  }
`;

const innerWrapperStyles = css`
  align-items: center;
  display: flex;
  gap: 5px;
`;

const EditChoicesLink = ({ onClick }) => {
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handleOnClick = () => {
    if (isFunction(onClick)) {
      if (isSnowplowTrackingEnabled) {
        sendTrackEvent({
          category: 'Traveler Details',
          action: 'Click',
          label: 'Back button',
        });
      }
      onClick();
    }
  };

  return (
    <LinkButton className={linkStyles} data-testid="edit-choices-button" onClick={handleOnClick}>
      <div className={innerWrapperStyles}>
        <CaretDown className={iconStyles} size="1.2em" variant="light" />
        {t('TD.EditPreviousChoices.Text')}
      </div>
    </LinkButton>
  );
};

EditChoicesLink.propTypes = {
  onClick: PropTypes.func,
};

export default EditChoicesLink;
